import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/group.select.tile.hbs';
import {tagName, template, on} from "../adapters/backbone-decorators";

require('interfaceAdapter');
require('metroHelpers');

@template(Template)
@tagName('span')
class GroupSelectTileView extends GenericView {

    constructor(options) {
        super(options);

        this.CCview = options.CCview;
        this.model.bind("change", this.render, this);
    }

    render() {
        super.render();
        this.$el.find('.tile').droppable({
            drop: (event, ui) => {
                var el = ui.draggable;

                $.ajaxDefaultQ({
                    url: `${this.model.url()}/items/${el.data("id")}`,
                    type: 'PUT',
                    dataType: 'json'
                }).done(data => {
                    if (data.outcome === "OK") {
                        this.model.fetch();
                    } else {
                        $.Notify.error(i18n.t("groups.contactingroup") + '.');
                    }
                }).fail(data => {
                    $.Notify.error(`${i18n.t("groups.putfailed")} = ${data.status ? data.status : ""}`);
                });
            }
        });

        if (this.CCview.model.get("includedGroups").indexOf("Group" + this.model.get(this.model.idAttribute)) !== -1) {
            this.$(".tile").addClass("selected");
            if (!this.CCview.isCampaignScheduled(this.CCview.model) && this.CCview.model.get("campaignId") !== 0) {
                this.$(".tile").addClass("disabled");
            }
        }

        if (this.model.get("description") === 'BOUNCED EMAILS' && this.CCview.model.get("campaignChannel") === "EMAIL") {
            this.$(".tile").remove();
        }

        this.$('[data-i18n]').i18n();
    }

    viewGroup() {
        var theId = this.model.get(this.model.idAttribute);
        document.location.href = "#Group/" + theId;
    }

    @on('click')
    select(ev) {
        if (!this.CCview.isCampaignScheduled(this.CCview.model) && this.CCview.model.get("campaignId") > 0) {
            return;
        }
        var id = this.model.get(this.model.idAttribute);
        var CCmodel = this.CCview.model;
        var attr = "includedGroups";
        var existingGroups = CCmodel.get(attr);
        var groupName = "Group" + id;
        var index = CCmodel.get(attr).indexOf(groupName);
        if (index === -1) {
            this.$(".tile").addClass("selected");
            existingGroups.push(groupName);
            this.CCview.changeTargeting(existingGroups, "group");
            this.trigger("GroupSelected", groupName);
        } else {
            this.$(".tile").removeClass("selected");
            existingGroups.splice(index, 1);
            this.CCview.changeTargeting(existingGroups, "group");
            this.trigger("GroupDeselected", groupName);
        }
        return false;
    }
}

export default GroupSelectTileView;
